export const initialState = {}
export const reducers = (state = initialState) => state
